import * as yup from "yup";

const nameRegex = /^[A-Za-z -'.]+$/;
const nucknameRegex = /^[A-Za-z.-_]+$/;

function imageSize(url) {
  const img = document.createElement("img");

  const promise = new Promise((resolve, reject) => {
    img.onload = () => {
      // Natural size is the actual image size regardless of rendering.
      // The 'normal' `width`/`height` are for the **rendered** size.
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      // Resolve promise with the width and height
      resolve({
        width,
        height,
      });
    };

    // Reject promise on error
    img.onerror = reject;
  });

  // Setting the source makes it start downloading and eventually call `onload`
  img.src = url;

  return promise;
}

export default {
  login: {
    email: yup.string().email("Email must be a valid email").required("Email is a required field"),
    password: yup.string().required(),
  },
  bookmark: {
    note: yup.string().required('Note is a required field').nullable(),
  },
  register: {
    name: yup
      .string()
      .matches(nameRegex, "Enter a valid name. Only English letters")
      .min(2)
      .max(35, "Must be exactly 15 characters")
      .required("Name is a required field"),
    email: yup
      .string()
      .email("Email must be a valid email")
      .required("Email is a required field"),
    password: yup
      .string()
      .matches(
        /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*()\-_=+{};:,<.>]){1,})([A-Za-z0-9!@#$%^&*()\-_=+{};:,<.>]{8,20})$/,
        "One uppercase and lowercase letter required, 8 characters minimum, one number required, one of the following special characters: !=+*;:-,._{[()]}#?@"
      )
      .required("Password is a required field"),
    password_confirmation: yup.string().oneOf([yup.ref("password")], "Passwords do not match"),
    tos: yup.string().test("tos", "Terms of Service is a required field", (value) => {
      return value;
    }),
  },
  count: {
    licenses: yup.number().nullable().required()
  },
  invite: {
    email: yup.string().email("Email must be a valid email").required("Email is a required field"),
  },
  assessments: {

  },
  quiz: {

  },
  update_learner: {
    email: yup.string().email("Email must be a valid email").required("Email is a required field"),
    name: yup
      .string()
      .matches(nameRegex, "Enter a valid name. Only English letters")
      .min(2)
      .max(35, "Must be exactly 15 characters")
      .required("Name is a required field"),
    nickname: yup
      .string()
      .matches(nucknameRegex, "Enter a valid Nickname. Only English letters")
      .min(2)
      .max(35, "Must be exactly 15 characters")
      .required("Nickname is a required field"),
  },
  learners: {
    learners: yup.array()
      .of(
        yup.object().shape({
          nickname: yup.string().label('Nickname').nullable(),
          name: yup.string().label('Name').nullable(),
          email: yup.string().label('Email').email().nullable().required('Email required field'),
        })
      )
      .required('Learners required field'),
  },
  // company: {
  //   name: yup
  //     .string()
  //     .matches(nameRegex, "Enter a valid company name. Only English letters")
  //     .min(2)
  //     .max(35, "Must be exactly 15 characters")
  //     .required("Name is a required field"),
  //   website: yup
  //     .string()
  //     .matches(
  //       /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
  //       "Enter a valid URL."
  //     )
  //     .required(),
  //   company_size: yup.string().required(),
  //   logo: yup
  //     .mixed()
  //     .test("fileResolution", "Recommended size 200x200 pixels", async (value) => {
  //       if (!value) {
  //         return true;
  //       }
  //       var _URL = window.URL || window.webkitURL;
  //       let file;
  //       file = value[0] || value;
  //       if (typeof value != "string") {
  //         var objectUrl = _URL.createObjectURL(file);
  //         const imageDimensions = await imageSize(objectUrl);
  //         return imageDimensions.width >= 100 && imageDimensions.height >= 100;
  //       }
  //     })
  //     .test("fileSize", "Maximum file size for the company logo is 2MB.", (value) => {
  //       if (!value) {
  //         return true;
  //       }

  //       let fileSize = ((value[0]?.size || value.size) / 1024 / 1024).toFixed(2);
  //       return value === null || fileSize <= 2;
  //     })
  //     .test("fileFormat", "Upload your company logo as a JPG or PNG file.", (value) => {
  //       if (!value) {
  //         return true;
  //       }
  //       return (
  //         value && ["image/jpeg", "image/jpg", "image/png"].includes(value[0]?.type || value.type)
  //       );
  //     }),
  //   tags: yup
  //     .array()
  //     .test("tags", "Please select tags", (value) => {
  //       return Array.isArray(value) ? value.length >= 1 && value.length <= 5 : true;
  //       // return Array.isArray(value) && !!value.length && value.length < 8;
  //     })
  //     .required(),
  // },
  // forgot: {
  //   email: yup.string().email("Email must be a valid email").required("Email is a required field"),
  // },
  // reset: {
  //   password: yup
  //     .string()
  //     .matches(
  //       /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*()\-_=+{};:,<.>]){1,})([A-Za-z0-9!@#$%^&*()\-_=+{};:,<.>]{8,20})$/,
  //       "One uppercase and lowercase letter required, 8 characters minimum, one number required, one of the following special characters: !=+*;:-,._{[()]}#?@"
  //     )
  //     .required("Password is a required field"),
  //   password_confirmation: yup.string().oneOf([yup.ref("password")], "Passwords do not match"),
  // },
  // two_factor: {
  //   code: yup.string().test("Please enter a code", (v) => v.replace("-", "").length == 6),
  // },
  // recovery_code: {
  //   recovery_code: yup.string().test("Please enter a code", (v) => v.replace("-", "").length == 20),
  // },
  // candidate: yup.array().of(
  //   yup.object({
  //     name: yup
  //       .string()
  //       .matches(nameRegex, "Only English letters")
  //       .min(2)
  //       .max(35, "Must be exactly 15 characters")
  //       .required("Name is a required field"),
  //     email: yup
  //       .string()
  //       .email("Email must be a valid email")
  //       .required("Email is a required field"),
  //   })
  // ),
  // // 'candidates-form': {
  // //   'candidate.name': yup.string().required().min(3),
  // //   'candidate.email': yup.string().email('Email must be a valid email').required("Email is a required field"),
  // // },
  // "candidates-form": {
  //   name: yup.string().required("Enter your name.").min(3),
  //   email: yup.string().email("Email must be a valid email").required("Enter your email."),
  //   citizenship: yup.string().required("Select your citizenship."),
  //   tos: yup.string().test("tos", "Accept our terms & conditions and privacy policy.", (value) => {
  //     return !!value;
  //   }),
  //   letter: yup.string().required().min(3).max(1000),
  //   cv: yup
  //     .mixed()
  //     .test("required", `Upload your CV file.`, (value) => {
  //       if (!value) {
  //         return false;
  //       }
  //       return true;
  //     })
  //     .test("fileSize", "CV cannot exceed 15 MB file size.", (value) => {
  //       if (!value) {
  //         return true;
  //       }

  //       let fileSize = ((value[0]?.size || value.size) / 1024 / 1024).toFixed(2);
  //       return value === null || fileSize <= 15;
  //     })
  //     .test("fileFormat", "CV file must be a PDF.", (value) => {
  //       if (!value) {
  //         return true;
  //       }
  //       return value && ["application/pdf"].includes(value[0]?.type || value.type);
  //     }),
  // },
  // name: {
  //   name: yup
  //     .string()
  //     .matches(nameRegex, "Only English letters")
  //     .min(2)
  //     .max(35, "Must be exactly 15 characters")
  //     .required("Name is a required field"),
  // },
  // logo: {
  //   logo: yup
  //     .mixed()
  //     .test("fileResolution", "Recommended size 200x200 pixels", async (value) => {
  //       if (!value) {
  //         return true;
  //       }
  //       var _URL = window.URL || window.webkitURL;
  //       let file;
  //       file = value[0] || value;
  //       if (typeof value != "string") {
  //         var objectUrl = _URL.createObjectURL(file);
  //         const imageDimensions = await imageSize(objectUrl);
  //         return imageDimensions.width >= 100 && imageDimensions.height >= 100;
  //       }
  //     })
  //     .test("fileSize", "Maximum file size for the company logo is 2MB.", (value) => {
  //       if (!value) {
  //         return true;
  //       }
  //       let fileSize = ((value[0]?.size || value.size) / 1024 / 1024).toFixed(2);
  //       return value === null || fileSize <= 2;
  //     })
  //     .test("fileFormat", "Upload your company logo as a JPG or PNG file.", (value) => {
  //       if (!value) {
  //         return true;
  //       }
  //       return (
  //         value && ["image/jpeg", "image/jpg", "image/png"].includes(value[0]?.type || value.type)
  //       );
  //     }),
  // },
  // email: {
  //   email: yup
  //     .string()
  //     .test("email_async_validation", "Email Validation Error", function (value) {
  //       const except = [
  //         "gmail.com",
  //         "gmx.ch",
  //         "yahoo.com",
  //         "mail.com",
  //         "mail.de",
  //         "bluewin.ch",
  //         "aol.com",
  //         "magenta.de",
  //         "tutanota.de",
  //         "web.de",
  //       ];
  //       const domain = value.slice(value.indexOf("@") + 1);
  //       if (except.includes(domain)) {
  //         return Promise.resolve(
  //           this.createError({ message: `Not allowed email domains "${domain}"` })
  //         );
  //       }
  //       return true;
  //     })
  //     .email("Email must be a valid email")
  //     .required("Email is a required field"),
  // },
  // password: {
  //   password: yup.string().required().min(3),
  //   // new_password: yup.string().required().min(3),
  //   new_password: yup
  //     .string()
  //     .matches(
  //       /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*()\-_=+{};:,<.>]){1,})([A-Za-z0-9!@#$%^&*()\-_=+{};:,<.>]{8,20})$/,
  //       "One uppercase and lowercase letter required, 8 characters minimum, one number required, one of the following special characters: !=+*;:-,._{[()]}#?@"
  //     )
  //     .required("Password is a required field"),
  //   password_confirmation: yup.string().oneOf([yup.ref("new_password")], "Passwords do not match"),
  // },
  // default_language: {
  //   default_language: yup.string().required(),
  // },
  // subscribe: {
  //   name: yup.string().required("Enter your name.").min(3),
  //   email: yup.string().email("Email must be a valid email").required("Enter your email."),
  //   // tos: yup.boolean().required(),
  //   tos: yup.string().test("tos", "Terms of Service is a required field", (value) => {
  //     return value == "true";
  //   }),
  //   // .test(
  //   //   "tos",
  //   //   "Accept our terms & conditions and privacy policy.",
  //   //   (value) => {
  //   //     console.log('value :>> ', value);
  //   //     return value;
  //   //   }
  //   // ),
  //   // tags: yup.array().of(yup.number()).min(1).max(5),
  //   tags: yup
  //     .array()
  //     .nullable()
  //     .test(
  //       "tags",
  //       "Select at least one technology(min 1 max 5 technologies can be selected)",
  //       (value) => {
  //         return Array.isArray(value) ? value.length >= 1 && value.length <= 5 : true;
  //       }
  //     ),
  // },
  // "job-offer": {
  //   title: yup.string().required(),
  //   state: yup.string().required(),
  //   // workload: yup.string().required(),
  //   seniority: yup.string().required(),
  //   salary_from: yup.string().required(),
  //   salary_to: yup.string().required(),
  //   city: yup.string().required(),
  //   street: yup.string().required(),
  //   street_number: yup.string().required(),
  //   postal_code: yup.string().required(),
  //   description: yup.string().required(),
  //   application_method: yup.string(),
  //   // remote_job: false,
  //   tech_stack: yup
  //     .array()
  //     .test(
  //       "tags",
  //       "Select at least one technology(min 1 max 5 technologies can be selected)",
  //       (value) => {
  //         return Array.isArray(value) ? value.length >= 1 && value.length <= 5 : true;
  //       }
  //     )
  //     .required(),
  //   perk: yup
  //     .array()
  //     .test(
  //       "tags",
  //       "Select at least one technology(min 1 max 5 technologies can be selected)",
  //       (value) => {
  //         return Array.isArray(value) ? value.length >= 1 && value.length <= 5 : true;
  //       }
  //     )
  //     .required(),
  // },
  edit_profile: {
    name: yup
      .string()
      .matches(nameRegex, "Enter a valid name. Only English letters")
      .min(2)
      .max(35, "Must be exactly 15 characters")
      .required("Name is a required field"),
    email: yup.string().email("Email must be a valid email").required("Email is a required field"),
    password: yup
      .string()
      .nullable()
      .test(
        "password",
        "One uppercase and lowercase letter required, 8 characters minimum, one number required, one of the following special characters: !=+*;:-,._{[()]}#?@",
        (val) => {
          if (!val) return true;
          return /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[~!@#$%^&*()\-_=+{};:,<.>?\'\[\]]){1,})([A-Za-z0-9~!@#$%^&*()\-_=+{};:,<.>?\'\[\]]{9,30})$/.test(val)
        }
      ),
    // .matches(
    //   /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[!@#$%^&*()\-_=+{};:,<.>]){1,})([A-Za-z0-9!@#$%^&*()\-_=+{};:,<.>]{8,20})$/,
    //   "One uppercase and lowercase letter required, 8 characters minimum, one number required, one of the following special characters: !=+*;:-,._{[()]}#?@"
    // ),
  },



  profile_address: {
    business_name: yup
      .string()
      .matches(nameRegex, "Enter a valid name. Only English letters")
      .min(2)
      .max(35, "Must be exactly 15 characters")
      .required("Name is a required field"),
    country: yup.string(),
    city: yup.string().required("City is a required field"),
    line_1: yup.string().required("Street Address is a required field"),
    line_2: yup.string(),
    state: yup.string().required("State Address is a required field"),
    postcode: yup.string(),
    delivery_same: yup.boolean(),
  },
};
